"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhonenumberPurchaseStatusEnum = void 0;
var PhonenumberPurchaseStatusEnum;
(function (PhonenumberPurchaseStatusEnum) {
    PhonenumberPurchaseStatusEnum["ERROR"] = "ERROR";
    PhonenumberPurchaseStatusEnum["PARTIAL"] = "PARTIAL";
    PhonenumberPurchaseStatusEnum["SUCCESS"] = "SUCCESS";
    PhonenumberPurchaseStatusEnum["WARNING"] = "WARNING";
})(PhonenumberPurchaseStatusEnum = exports.PhonenumberPurchaseStatusEnum || (exports.PhonenumberPurchaseStatusEnum = {}));
